import { CountryNameFragment, LanguageNameFragment } from "../../../Utilities";
import * as CountryFormat from "../Country";
import * as LanguageFormat from "../Language";

export function nationalities(nationalities: CountryNameFragment[]) {
	return nationalities.map(CountryFormat.name).join(", ");
}

export function languages(languages: LanguageNameFragment[]) {
	return languages.map(LanguageFormat.name).join(", ");
}
